import Board from "components/Common/Board/Board";
import React from "react";
import styled from "styled-components";
import UserDashboardPageHeader from "components/Common/DashboardPageHeader/DashboardPageHeader";
import { PageFilterPanel } from "components/Common/PageFilterPannel";
import FilterSearch from "components/Common/PageFilterPannel/FilterSearch";
import { Table } from "components/Common/Table/Table";
import Button from "components/foundation/Button";
import { DocumentCategoryTagResponse } from "apis/data-contracts";
import { Link, useNavigate } from "react-router-dom";
import { ROUTER_PATH } from "config/path";
import useTagsAutoCompleteQuery from "features/tag/hooks/queries/useTagsAutoCompleteQuery";
import { useFormContext } from "react-hook-form";
import { TagDashboardFormData } from "..";
import SearchEmpty from "components/Common/Empty/SearchEmpty";
import { useDocumentClassesByCategoryQuery } from "features/document/hooks/queries/useDocumentClassesByCategoryQuery";

interface TagDashboardWebPageProps {
  tags: DocumentCategoryTagResponse[];
}

const TagDashboardWebPage = ({ tags }: TagDashboardWebPageProps) => {
  const navigate = useNavigate();
  const { watch } = useFormContext<TagDashboardFormData>();
  const { data } = useTagsAutoCompleteQuery({
    searchTerm: watch("search"),
  });

  //ARCHIEVE 문서구분태그 조회
  const { data: documentClasses } = useDocumentClassesByCategoryQuery(
    tags[2].documentCategoryUuid,
  );

  const filteredTags = tags.filter(
    (tag) =>
      tag.tagCategories?.[0]?.tags?.length ||
      tag.tagCategories?.[1]?.tags?.length ||
      tag.tagCategories?.[2]?.tags?.length,
  );

  return (
    <TagDashboardPageLayout>
      <UserDashboardPageHeader title="TAG MANAGEMENT" />
      <PageFilterPanel.Board>
        <FilterSearch
          autocomplete={data?.data.result.map((i) => ({
            label: i,
            value: i,
          }))}
        />
      </PageFilterPanel.Board>
      <ContentBoard>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Table.TotalCount>총 {filteredTags.length}건 </Table.TotalCount>
          <Link to={ROUTER_PATH.tag.create}>
            <Button>법인명 등록</Button>
          </Link>
        </div>
        {filteredTags.length === 0 ? (
          <SearchEmpty />
        ) : (
          <Table.Layout>
            <Table.Table columns="auto auto 1fr 1fr 1fr">
              <Table.Thead>
                <Table.Th>No.</Table.Th>
                <Table.Th>문서종류</Table.Th>
                <Table.Th>태그 #01</Table.Th>
                <Table.Th>태그 #02</Table.Th>
                <Table.Th>태그 #03</Table.Th>
              </Table.Thead>
              <Table.Tbody>
                {filteredTags.map((tag, index) => {
                  return (
                    <Table.Tr
                      key={tag.documentCategoryUuid}
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        navigate(
                          ROUTER_PATH.tag.dashboard.detail._path(
                            tag.documentCategoryUuid,
                          ),
                        );
                      }}
                    >
                      <Table.Td>{index + 1}</Table.Td>
                      <Table.Td>{tag.documentCategoryName}</Table.Td>
                      <Table.Td>
                        {tag.documentCategoryName === "ARCHIVES"
                          ? documentClasses?.map((i) => i.name).join(", ")
                          : tag.tagCategories?.[0]?.tags
                              .map((i) => i.tagName)
                              .join(", ")}
                      </Table.Td>
                      <Table.Td>
                        {tag.documentCategoryName === "ARCHIVES"
                          ? tag.tagCategories?.[0]?.tags
                              .map((i) => i.tagName)
                              .join(", ")
                          : tag.tagCategories?.[1]?.tags
                              .map((i) => i.tagName)
                              .join(", ")}
                      </Table.Td>
                      <Table.Td>
                        {tag.documentCategoryName === "ARCHIVES"
                          ? tag.tagCategories?.[1]?.tags
                              .map((i) => i.tagName)
                              .join(", ")
                          : tag.tagCategories?.[2]?.tags
                              .map((i) => i.tagName)
                              .join(", ")}
                      </Table.Td>
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table.Table>
          </Table.Layout>
        )}
      </ContentBoard>
    </TagDashboardPageLayout>
  );
};

export default TagDashboardWebPage;

const TagDashboardPageLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const ContentBoard = styled(Board)`
  padding: 4rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
